export default __webpack_public_path__ + "static/17_33-469392cb3bc6b2ac44c212cfdc60a6ba.png";